import React from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import "../styles/components/_bodyText.scss"

const BodyText = ({ text }) => {
  return <div className="body-text">{documentToReactComponents(text)}</div>
}

export default BodyText
